import { Button, CircularProgress, Typography } from "@material-ui/core";

type DialogButtonProps = {
  color?: "default" | "primary" | "secondary";
  label?: string;
  disabled?: boolean;
  isProcessing?: boolean;
  onClick?: () => void;
};

/**
 * ダイアログ用のボタンコンポーネントです。
 */
export const DialogButton: React.FC<DialogButtonProps> = ({
  color = "default",
  label = "button",
  disabled = false,
  isProcessing = false,
  onClick = () => {},
}) => {
  return (
    <Button
      variant="text"
      color={color}
      disableRipple
      disabled={isProcessing || disabled}
      onClick={isProcessing ? () => {} : onClick}
    >
      {isProcessing ? (
        <CircularProgress
          size={24}
          color={color === "default" ? "inherit" : color}
        />
      ) : (
        <Typography variant="h6">{label}</Typography>
      )}
    </Button>
  );
};
